import Footer from "./Footer";
import Navbar from "./Navbar";

function Layout({ currentPath, onNavigate, children }) {
  return (
    <div className="min-h-screen bg-background text-primary">
      <Navbar currentPath={currentPath} onNavigate={onNavigate} />
      {children}
      <Footer onNavigate={onNavigate} />
    </div>
  );
}

export default Layout;
